<template>
  <header
      :class="{'header-line':line , 'bg-white shadow-md': scrolled, 'bg-transparent': !scrolled, 'fixed top-0 inset-x-0 z-50': !relative, 'relative': relative}">
    <div class="w-full">
      <div class="flex justify-between items-center md:justify-start md:space-x-10">
        <div class="flex justify-start lg:w-0 flex-1 logo">
          <a href="/">
            <img v-if="scrolled || relative" src="/logo/artfield-logo-black.png" alt="Logo dark">
            <img v-else src="/logo/artfield-logo.png" alt="Logo light">
          </a>
        </div>
        <div class="flex items-center justify-end">
          <button v-if="!user" class="login-button a6 mr-2 p-2" :class="{'reverse': scrolled || relative}"
                  @click="router.push('/welcome-to-artfield')">
            Register
          </button>
          <button v-if="!user" class="login-button a6 mr-2 p-2" :class="{'reverse': scrolled || relative}"
                  @click="router.push('/login')">
            Log in
          </button>
          <button v-else class="login-button a6" :class="{'reverse': scrolled || relative}"
                  @click="router.push('/field/feed')">
            The field
          </button>
          <div v-if="!hideMenu" class="menu-icon" @click="togglePanel">
            <!-- Hamburger icon -->
            <img v-if="scrolled || relative" :src="'/icons/hamburger-black.png'" alt="Menu">
            <img v-else :src="'/icons/hamburger-white.png'" alt="Menu">
          </div>
        </div>
      </div>
    </div>
    <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div v-show="isOpen" class="fixed inset-y-0 right-0 flex w-full menu-panel">
        <div class="w-1/2 bg-black bg-opacity-80 cursor-pointer" @click="isOpen = false"></div>
        <div class="w-1/2 red-bg space-y-1 transition-all duration-500 ease-in-out relative">
          <div class="flex px-7 pt-3 justify-between items-center md:justify-start md:space-x-10">
            <div class="flex justify-start lg:w-0 lg:flex-1 logo">
              <a href="/">
                <img src="/logo/artfield-logo.png" alt="Logo light">
              </a>
            </div>
            <div class="flex items-center justify-end">
              <button v-if="!user" class="login-button a6"
                      @click="router.push('/login')">
                Log in
              </button>
              <button v-if="!user" class="login-button a6 ml-2"
                      @click="router.push('/welcome-to-artfield')">
                Register
              </button>

              <button v-else class="login-button a6"
                      @click="router.push('/field/feed')">
                The field
              </button>
              <div class="menu-icon" @click="togglePanel">
                <img src="/icons/x-icon.png" alt="Menu">
              </div>
            </div>
          </div>
          <ul class="px-7 py-5">
            <li v-for="item in menuItems" :key="item.url">
              <router-link :to="user ? item.url : item.url2" class="m1">{{ item.name }}</router-link>
            </li>
          </ul>
          <ul class="absolute bottom-0 left-0 mb-5 space-y-0 p-7">
            <li v-for="item in bottomItems" :key="item.url">
              <router-link :to="item.url" class="m2">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup lang="ts">
import {ref, onMounted, onUnmounted, nextTick, watchEffect} from 'vue';
import {useRoute} from "vue-router";
import {useRouter} from "vue-router";
import {useUserStore} from "~/composables/useUserStore";

const scrolled = ref(false);
const isOpen = ref(false);
const route = useRoute();
const router = useRouter();
const {user} = useUserStore();

const props = defineProps({
  relative: {
    type: Boolean,
    default: false
  },
  hideMenu: {
    type: Boolean,
    default: false
  },
  line: {
    type: Boolean,
    default: false
  }
});


const menuItems = [
  {name: 'About', url: '/about', url2: '/about'},
  {name: 'Talents', url: '/field/talents', url2: '/welcome-to-artfield'},
  {name: 'Reads', url: '/reads', url2: '/welcome-to-artfield'},
  {name: 'Membership', url: '/about?q=membership', url2: '/about'},
  {name: 'Services', url: '/about?q=services', url2: '/about'},
  {name: 'Contact', url: '/about?q=contact', url2: '/about'}
];

const bottomItems = [
  {name: 'Help Center', url: '/help'},
  {name: 'Privacy Policy', url: '/terms-and-conditions'},
  {name: 'Terms and Conditions', url: '/terms-and-conditions?id=1'},
  {name: 'Copyright & Trademark', url: '/terms-and-conditions?id=2'},
  {name: 'Clarification Text', url: '/terms-and-conditions?id=3'},
  {name: 'Cookie Policy', url: '/terms-and-conditions?id=4'}
];


const handleScroll = () => {
  const offset = window.scrollY;
  scrolled.value = offset > 50;
};

const togglePanel = () => {
  isOpen.value = !isOpen.value;
};

const beforeEnter = (el: any) => {
  el.style.transform = 'translateX(100%)';
};

const enter = (el: any, done: any) => {
  setTimeout(() => {
    el.style.transform = 'translateX(0%)';
    done();
  }, 1);
};

const leave = (el: any, done: any) => {
  el.style.transition = 'transform 0.5s ease';
  el.style.transform = 'translateX(100%)';
  setTimeout(done, 500);
};

onMounted(() => {
  console.log('user', user.value);
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

watchEffect(() => {
  if (route.fullPath) { // Checking if there is any change in full path
    isOpen.value = false; // Close the panel if there is a change
  }
});

</script>

<style scoped>
</style>
